import { GSkeletonDisplayText } from '~/presentation/common';

export const PAChartSkeleton = () => {
  return <GSkeletonDisplayText height="188px" />;
};
